import { render, staticRenderFns } from "./NavigationBarButton.vue?vue&type=template&id=e401f2f4&scoped=true"
import script from "./NavigationBarButton.vue?vue&type=script&lang=js"
export * from "./NavigationBarButton.vue?vue&type=script&lang=js"
import style0 from "./NavigationBarButton.vue?vue&type=style&index=0&id=e401f2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e401f2f4",
  null
  
)

export default component.exports